<template>
  <div id="menu" :class="display">
  	<ul>
  		<li class="title-li barlow">NAVIGATION</li>
  		<li v-for="(view, i) in $content" v-on:click="gotoView($event, i)"  :class="{active: (viewIndex==i)}">{{view.title}}</li>
  		<a href="./downloads/2019AnnualReport.pdf" target="_blank"><li>PDF Download</li></a>
  	</ul>
  </div>
</template>

<script>
  export default {
    name: 'mainMenu',
    props: {
    	showMenu: Boolean,
    	toggleMenu: Function,
    	viewIndex: Number
    },
    computed: {
    	display: function() {
			return this.showMenu ? 'display' : '';
		}
    },
    methods: {
    	gotoView: function(e, i) {
    		this.$emit('toggleMenu');
    		if(this.viewIndex !== i){
    			this.$emit('changeView', i);
    		} else {
    			this.$emit('changeSlide', 0);
    		}
    	}
    }
  } 
</script>

<style lang="scss">
	@import '../sass/variables';

	#menu{
		position: absolute;
		width: 100%;
		height: 100%;
		background: $lightpurple;
		z-index: 8;
		transform: translate(100%, 0);
		transition: transform 600ms ease-out;
		&.display{
			transform: translate(0, 0);
		}
		ul{
			display: flex;
			height: 100%;
			width: 100%;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			a{
				text-decoration: none;
			}
			li{
				color: #fff;
				cursor: pointer;
				@include vw-pixels((
					'font-size': 40,
					'margin-top': 20,
					'margin-bottom': 20,
		        ), 1.2);
		        position: relative;
		        &:before{
		        	content: '';
		        	width: 100%;
		        	position: absolute;
		        	height: 2px;
		        	background: $blue;
		        	bottom: 0;
		        	transform: scaleX(0);
		        	transition: transform 400ms ease-out;
		        }
		        &.title-li{
		        	color: $blue;
		        	@include vw-pixels((
						'font-size': 14
			        ), 1.6);

		        }
		        &.active, &:hover{
		        	&:before{
		        		transform: scaleX(1);
		        	}
		        }
			}
		}
	}
</style>